<template lang="html">

  <section class="newsletter" :white="$route.path != '/'">
    <h2 class="hand-title">Suscríbete a nuestra newsletter</h2>
    <form id="form-newsletter" class="container-xs" @submit.prevent="send">
      <div class="contenedor-input row-between">
        <input type="email" name="email" :placeholder="$t('formulario.email_placeholder')" required>
        <button class="classic-btn" tooltip="Enviar">Enviar</button>
      </div>
      <div class="contenedor-check">
        <input type="checkbox" id="politica-newsletter" required>
        <label for="politica-newsletter">He leído y acepto la <a target="_blank" href="http://www.carretilla.info/aviso-legal">política de privacidad</a></label>
      </div>

      <p class="legal">En cumplimiento de la normativa vigente en materia de protección de datos le informamos que el responsable de sus datos personales es INDUSTRIAS ALIMENTARIAS NAVARRA S.A.U., y los utilizará para atender las solicitudes de información. Este tratamiento está basado en su consentimiento. Los datos personales recabados no serán en ningún caso cedidos a terceros salvo por obligaciones legales expresas. Puede ejercer los derechos que le asisten sobre protección de datos en la dirección info@grupoian.com. Puede consultar información adicional sobre Protección de Datos en este enlace.</p>

      <p class="error">Este correo ya existe en nuestra base de datos</p>

      <input type="hidden" name="from" value="esparragosCarretilla">

    </form>

      <h3 class="hand-title correcto row-center">¡Gracias por suscribirte!<br>Muy pronto tendrás noticias nuestras.</h3>
  </section>

</template>

<script lang="js">


  import axios from 'axios';
  import VueAxios from 'vue-axios';

  export default  {
    name: 'newsletter',
    methods : {
      send : function(){

       axios.post(`https://mailservice.doubledot.es/send-suscribe`, $("#form-newsletter").serialize())
       .then(response => {
        if(response.data == 1){
          $("#form-newsletter")[0].reset();
          $(".correcto").addClass('show');
          $("form").addClass('animated fadeOutUp');
          $(".hand-title:not(.correcto)").addClass('animated fadeOutUp');
          $(".error").hide();
        }else{
          $(".error").show();
        }
      })
       .catch(error => reject(error));
     }
   },
 }
</script>

<style scoped lang="scss">
.newsletter {
  width: 100%;
  background: url(/static/img/background-madera.jpg) center/cover no-repeat;
  padding: 50px 0;
  padding-top: 25px;
  position: relative;
}

.newsletter[white=true]{
  background: white;
}

.correcto{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  pointer-events: none;
  opacity: 0!important;
  padding: 0 15px;
}

.correcto.show{
  animation-name: fadeIn;
}

.contenedor-input{
  margin-top: 30px;
  margin-bottom: 10px;
}

.contenedor-input input{
  width: calc(100% - 120px);
  height: 40px;
  line-height: 40px;
  background: white;
  border:1px solid #967842;
  color: #967843;
  padding: 0 10px;
  outline: none;
  border-radius: 0;
}

.contenedor-input input::placeholder{
  color: #967842;
  font-family: 'Raleway';
  font-style:italic;
}

.contenedor-input button{
  width: 110px;
  background: transparent;
  outline: none;
  font-size: 16px;
}

.contenedor-check{
  position: relative;
}

.contenedor-check input{
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 20px;
  height: 20px;
}

.contenedor-check label{
  text-align: left;
  width: 100%;
  display: inline-block;
  padding-left: 25px;
  position: relative;
  font-family: 'Raleway';
  font-style:italic;
  color: #212c55;
  cursor: pointer;
}

.contenedor-check label a{
  text-decoration: underline;
  font-family: 'Raleway';
}

.contenedor-check label::before{
  width: 15px;
  height:15px;
  display: inline-block;
  background: white;
  border: 1px solid #212c55;
  content: "\2713";
  position: absolute;
  left: 0;
  top:0;
  line-height: 17px;
  font-size: 12px;
  text-align: center;
  color: transparent;
}

.contenedor-check input:checked + label::before{
  color: #212c55;
}

.error{
  width: 100%;
  text-align: left;
  color: red;
  font-size: 14px;
  display: none; 
}

.legal{
  font-size: 14px;
  text-align: left;
  display: inline-block;
  line-height: 1.2em;
  margin-top: 10px;
}


</style>



// WEBPACK FOOTER //
// src/components/parts/newsletter.vue